import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "@components/ui/button";
import { DeployPanel } from "@components/deploy/DeployPanel";

export default function ConnectionErrorScreen({ actions }: { actions?: React.ReactNode }) {
  return (
    <DeployPanel.Root>
      {actions && (
        <DeployPanel.Header>
          <div />
          <DeployPanel.Actions>{actions}</DeployPanel.Actions>
        </DeployPanel.Header>
      )}
      <DeployPanel.Body centered className="p-12">
        <div className="max-w-md w-full text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4">
            <ExclamationTriangleIcon className="size-7 text-amber-600" />
          </div>

          <h2 className="text-xl font-semibold text-base-600">
            Unable to connect to the deployment server
          </h2>
          <p className="text-sm text-base-500 mt-2">
            This may be a temporary issue. Your deploy will continue in the
            background.
          </p>

          <Button onClick={() => window.location.reload()} className="mt-6">
            Reload page
          </Button>
        </div>
      </DeployPanel.Body>
    </DeployPanel.Root>
  );
}
